// eslint-disable-next-line import/no-unresolved
import axios from './axios';
import store from '../store/store';
import router from './router';

// Changes all of an object's keys to camel case
const sanitise = (obj) => {
  const newObj = {};

  if (obj instanceof Array) {
    return obj.map((value) => {
      if (typeof value === 'object') {
        return sanitise(value);
      }
      return value;
    });
  }

  Object.keys(obj).forEach((origKey) => {
    const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
    let value = obj[origKey];
    if (value instanceof Array || (value !== null && value.constructor === Object)) {
      value = sanitise(value);
    }
    newObj[newKey] = value;
  });

  return newObj;
};

const verifyResponse = async (response) => {
  if (response.config.excludeToken) return response;

  if ((response.status === 401 || response.status === 403)
      && !router.currentRoute.path.startsWith('/Login')
  ) {
    await store.dispatch('logout', { includeReturnUrl: true });
  }
  return response;
};

// Add the access token to each request
axios.interceptors.request.use((axiosConfig) => {
  const csrfToken = localStorage.getItem('csrfToken');
  if (csrfToken) {
    // eslint-disable-next-line no-param-reassign
    axiosConfig.headers['X-Csrf-Token'] = csrfToken;
  }
  return axiosConfig;
});

// Check token on failure
axios.interceptors.response.use(
  (response) => verifyResponse(response),
  (error) => {
    throw error;
  },
);

// All requests are sanitised to camel case
axios.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'application/json; charset=utf-8') {
    response.data = sanitise(response.data);
  }
  return response;
});
